import React, {useContext, useEffect, useState} from 'react';
import {Button, Col, ConfigProvider, DatePicker, Form, Input, Modal, Row, Select} from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import locale from "antd/es/locale/es_ES";
import {GetEscoles} from "../../../dao/root/GetEscoles";
import { PostProposta } from '../../../dao/menudesign/comandes/PostProposta';
import {AuthContext} from "../../../config/AuthContext";
import {Escola} from "../../../model/root/Escola";
import Proposta from "../../../model/menudesign/comandes/Proposta";

import dayjs from "dayjs";
const {TextArea} = Input;
const {Option} = Select;

interface PropostatModalProps {
    element: Proposta;
    visible: boolean;
    onClose: (value: boolean) => void;
    editar?: boolean;
}

const PropostaModal: React.FC<PropostatModalProps> = ({element, visible, onClose, editar}) => {
    const [form] = Form.useForm();
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const [coleccio, setDades] = useState<any[]>([]);
    const esSuperusuari = user?.rol?.some((rol: any) => rol.nom === "superusuari");
    const escolesVisibles = esSuperusuari ?  coleccio : user.escoles ;

   useEffect(() => {
        if (isLoggedIn) {
            console.log("es super usuari", esSuperusuari )
        console.log("idEscola USURIO:", user.escoles);
            checkDades();
        }
    }, [isLoggedIn]);

    async function handleSubmit () {
        const formData = form.getFieldsValue();
        const payload = {
        ...formData,
        inici: formData.inici ? formData.inici.format("YYYY-MM-DD") : null,
        fin: formData.fin ? formData.fin.format("YYYY-MM-DD") : null,
    };
        await PostProposta(page, payload, userId);
        onClose(true);
    };

    async function checkDades() {
        const dades = await GetEscoles(page);
        setDades(dades|| []);
        console.log("idEscolES TOTAL:", coleccio);
    }
    const handleCancel = () => {
        onClose(false);
    };

    return (
        <ConfigProvider locale={locale}>
        <Modal
            title="Crear/Editar Proposta"
            open={visible}
            onCancel={handleCancel}
            footer={[
            ]}
            width={900}
        >
            <Form form={form} initialValues={{
                        ...element,
                        idEscola: element?.idEscola ? String(element.idEscola) : undefined,
                        inici: element?.inici ? dayjs(element.inici) : null,
                        fin: element?.fin ? dayjs(element.fin) : null,
                    }} onFinish={handleSubmit} disabled={!editar}>
                <hr/>
                   
                        <Form.Item label="ID" name="id">
                            <Input disabled/>
                        </Form.Item>

                        <Form.Item
                        label="Escola"
                        name="idEscola"
                        rules={[{required: true, message: 'Aquest camp es obligatori'}]}
                        >
                           <Select placeholder="Selecciona una escola">
                            {escolesVisibles?.map((escola: Escola) => (
                                <Option key={escola.id} value={escola.id}>
                                {escola.nom}
                                </Option>
                            ))}
                            </Select>
                        </Form.Item>
                    <Row gutter={[8, 8]}>
                        <Col span={12}>
                            <Form.Item
                            label="Inici"
                            name="inici"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}
                        >
                            <DatePicker format="DD/MM/YYYY" style={{width: "100%"}}/>
                        </Form.Item>
                        </Col>
                        <Col span={12}>
                        <Form.Item
                            label="Final"
                            name="fin"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}
                        >
                            <DatePicker format="DD/MM/YYYY" style={{width: "100%"}}/>
                        </Form.Item>
                        </Col>
                    </Row>

                     <Form.Item
                        label="Comentaris"
                        name="comentaris"
                        rules={[{required: true, message: 'Aquest camp es obligatori'}]}
                    >
                        <TextArea rows={4}/>
                    </Form.Item>
                    
                <hr/>
                <Row gutter={[16, 16]}>
                    <Col span={1}>
                        <Form.Item wrapperCol={{offset: 0, span: 16}}>
                            <Button title={"Aceptar"} htmlType={"submit"}
                                    style={{backgroundColor: Colors.colors.color6}}><BiCheck/></Button>
                        </Form.Item>
                    </Col>
                    <Col span={1}>
                    </Col>
                    <Col span={1}>
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </Col>
                </Row>
            </Form>
        </Modal>
        </ConfigProvider>
    );
};

export default PropostaModal;
